import axios from "axios";

async function check(store){

  // ログイン時のみ対応
  if(store.getters['auth/isLogin']){
    // デターの同期チェック
    store.dispatch("auth/getUpdate")

    // トラッキングコード同期
    store.dispatch("tracking_code/sync")

    // oneSignal
    store.dispatch("auth/updateOneSignalDeviseToken")

  } // ログイン 

  // アプリ・バージョンアップ
  try {
    // version.jsonファイルから最新のバージョンを取得（キャッシュバスティング）
    const res = await axios.get("/version.json", {
      headers: { 'Cache-Control': 'no-cache' },
      params: { _t: Date.now() }
    });
    const data = res.data;
    const latestVersion = data.version;

    // 環境変数から現在のバージョンを取得
    const curVersion = !!process.env.VERSION ? Number(process.env.VERSION) : 0;

    // 最新バージョンよりも古かったら、強制的にリロードする
    // 同じバージョンで既にリロード済みなら無限ループ防止のためスキップ
    if (curVersion < latestVersion) {
      const RELOAD_FLAG = 'version_update_reload'
      try {
        const savedVersion = sessionStorage.getItem(RELOAD_FLAG)
        if (savedVersion === String(latestVersion)) {
          console.warn(`Already reloaded for version ${latestVersion}, skipping`)
          return
        }
        sessionStorage.setItem(RELOAD_FLAG, String(latestVersion))
      } catch {
        // sessionStorageが使えない場合はリロードせずスキップ（ループ防止）
        console.warn('sessionStorage unavailable, skipping reload')
        return
      }
      console.log(`Version update detected: ${curVersion} -> ${latestVersion}`)
      window.location.reload()
    }
  } catch(error) {
    console.error(error);
    // エラーのときはなにもしない
  }
}

// まずSettimeoutで初期チェック、その後1分毎に自動チェック
export default async ({store, route, query}) => {

  // トラッキングコードセット
  // トラッキングコードがなければOtherにセット
  if(route.name === "user-uuid"){
    store.commit("tracking_code/setCode", `c_${route.params.uuid}`)
  }else if(route.name === "post-uuid"){
    store.commit("tracking_code/setCode", `p_${route.params.uuid}`)
  }else if(route.name === "tag-name"){
    store.commit("tracking_code/setCode", `t_${route.params.name}`)
  }else if(query.tc){
    store.commit("tracking_code/setCode", query.tc)
  }else{
    store.commit("tracking_code/setCode", `other`)
  }

  // 起動1秒後実行
  window.setTimeout(async () => {
    // useragent
    const ua = navigator.userAgent
    let isIosApp = !!ua.match(/iOS_App/)
    store.commit('userAgent/set', {isIosApp: isIosApp, ua: ua})
    let isTouchDevice = false
    if(/android/i.test(ua)) isTouchDevice = true
    if(/iPad|iPhone|iPod/i.test(ua) || isIosApp) isTouchDevice = true
    store.commit('devise/setIsTouchDevice', isTouchDevice)

    // ログインしていたらマスタの更新
    if (store.getters['auth/isLogin']){
      console.log("this is login data get")
      // ホームの mounted が直前に取っていれば使い回す（同じ dashboard を2回取らない）
      store.dispatch("master/getDashboard", { reuseRecent: true })
      store.dispatch('master/getClient')
    }
  }, 1000)

  // 起動時だと処理できない箇所があったので５秒後
  window.setTimeout(async () => {
    // 諸々のチェック
    check(store)

    // 古いデータ削除
    store.commit("auth/clearOldData")

    // 認証データのリフレッシュ
    if (store.getters['auth/isLogin']) store.dispatch('auth/refreshToken')
  }, 1000 * 5);

  // 5分に1回
  window.setInterval(() => {check(store)}, 1000 * 60 * 5);
}